(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("1mc4X", function(module, exports) {

$parcel$export(module.exports, "debounce", function () { return $0fd1372480c1efe9$export$61fc7d43ac8f84b0; });

var $7f7I9 = parcelRequire("7f7I9");

var $4ojSe = parcelRequire("4ojSe");
var $0fd1372480c1efe9$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0fd1372480c1efe9$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $0fd1372480c1efe9$var$_this = undefined;
var $0fd1372480c1efe9$export$61fc7d43ac8f84b0 = function(func, delay) {
    var timeoutId;
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        clearTimeout(timeoutId);
        timeoutId = setTimeout(function() {
            func.apply($0fd1372480c1efe9$var$_this, args);
        }, delay);
    };
};
var $0fd1372480c1efe9$var$searchForms = document.querySelectorAll(".f-search");
$0fd1372480c1efe9$var$searchForms.forEach(function(form) {
    var input = form.querySelector(".f-text__input");
    var dropdownWrapper = form.querySelector(".f-search__dropdown-content");
    var searchFetch = function(value) {
        return $0fd1372480c1efe9$var$__awaiter(void 0, void 0, void 0, function() {
            var response, _a, data;
            return $0fd1372480c1efe9$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        form === null || form === void 0 || form.classList.add("--searching");
                        if (!form.classList.contains("--herbs")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $7f7I9.searchApi).searchHerbs(value)
                        ];
                    case 1:
                        _a = _b.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            (0, $7f7I9.searchApi).search(value)
                        ];
                    case 3:
                        _a = _b.sent();
                        _b.label = 4;
                    case 4:
                        response = _a;
                        if (!(response && response.ok)) return [
                            3 /*break*/ ,
                            6
                        ];
                        return [
                            4 /*yield*/ ,
                            response.json()
                        ];
                    case 5:
                        data = _b.sent();
                        console.log(data);
                        if (!data.success) {
                            form.classList.remove("--searching");
                            return [
                                2 /*return*/ 
                            ];
                        }
                        if (dropdownWrapper) dropdownWrapper.innerHTML = "";
                        dropdownWrapper === null || dropdownWrapper === void 0 || dropdownWrapper.insertAdjacentHTML("beforeend", data.html);
                        if (data.datalayerPush) (0, $4ojSe.datalayerPush)(data.datalayerPush);
                        _b.label = 6;
                    case 6:
                        form === null || form === void 0 || form.classList.remove("--searching");
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var debouncedFetch = $0fd1372480c1efe9$export$61fc7d43ac8f84b0(function(value) {
        return $0fd1372480c1efe9$var$__awaiter(void 0, void 0, void 0, function() {
            return $0fd1372480c1efe9$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    searchFetch(value)
                ];
            });
        });
    }, 300);
    input === null || input === void 0 || input.addEventListener("input", function() {
        if (input.value.length == 3) searchFetch(input.value);
        if (input.value.length >= 3) {
            debouncedFetch(input.value);
            form.classList.remove("--first-search");
        } else form.classList.add("--first-search");
    });
});

});
parcelRegister("7f7I9", function(module, exports) {

$parcel$export(module.exports, "searchApi", function () { return $545fea66f7228867$export$6d1f7a27488e914c; });
var $545fea66f7228867$var$__assign = undefined && undefined.__assign || function() {
    $545fea66f7228867$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $545fea66f7228867$var$__assign.apply(this, arguments);
};
var $545fea66f7228867$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $545fea66f7228867$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $545fea66f7228867$var$SearchApi = /** @class */ function() {
    function SearchApi() {
        this.responseSettings = {
            method: "POST"
        };
        this.currentAbortController = null;
    }
    SearchApi.prototype.makeRequest = function(url, value) {
        return $545fea66f7228867$var$__awaiter(this, void 0, void 0, function() {
            var signal, response, error_1;
            return $545fea66f7228867$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.currentAbortController) this.currentAbortController.abort();
                        this.currentAbortController = new AbortController();
                        signal = this.currentAbortController.signal;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            fetch("".concat(url, "/").concat(value), $545fea66f7228867$var$__assign($545fea66f7228867$var$__assign({}, this.responseSettings), {
                                signal: signal
                            }))
                        ];
                    case 2:
                        response = _a.sent();
                        if (!response.ok) throw new Error("Request failed with status ".concat(response.status));
                        return [
                            2 /*return*/ ,
                            response
                        ];
                    case 3:
                        error_1 = _a.sent();
                        if (error_1.name === "AbortError") console.log("Previous request aborted");
                        else {
                            console.error("An error occurred:", error_1);
                            throw error_1; // Propagate the error for handling at a higher level if needed
                        }
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    // Performs a generic search
    SearchApi.prototype.search = function(value) {
        return $545fea66f7228867$var$__awaiter(this, void 0, void 0, function() {
            return $545fea66f7228867$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.makeRequest("/search", value)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    // Performs a search for herbs
    SearchApi.prototype.searchHerbs = function(value) {
        return $545fea66f7228867$var$__awaiter(this, void 0, void 0, function() {
            return $545fea66f7228867$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.makeRequest("/search-herbs", value)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    return SearchApi;
}();
var $545fea66f7228867$export$6d1f7a27488e914c = new $545fea66f7228867$var$SearchApi();

});


})();
//# sourceMappingURL=search-handle.1833f2c2.js.map
